import React, {Component} from 'react';
import PolyUtil from "../util/PolyUtil";
import {
    Col,
    Collapse,
    FormFeedback, FormGroup, FormText,
    Input, InputGroup, InputGroupAddon,
    Label,
    Row
} from 'reactstrap';
import Geosuggest from 'react-geosuggest';
import Stepper from '../components/controls/inputs/Stepper';
import BoolButtons from "../components/controls/buttons/BoolButtons";
import Rheostat from 'rheostat';
import moment from 'moment';

import Checkbox from "../components/controls/inputs/Checkbox";
import {normalizeDate} from "../util/normalizers";

/*global google*/
/*eslint no-undef: "error"*/

// basic wrapper integrating reactstrap UI with redux-form to show validation issues
// toggles validationState based on meta from redux-form
export class InputField extends Component {
    state = {
        length: 0
    };

    render() {
        const {input, label, type, placeholder, style, addon, addon_end, meta: {touched, error, warning}, min, max, maxChars, step, rows} = this.props;
        const validationState = touched ? ((error && 'danger') || (warning && 'danger') || 'default') : 'default';
        const valid = touched ? ((error || warning) ? false : null) : null;
        return (
            <FormGroup color={validationState}>
                {(label === null || label === undefined) ? null : <Label>
                    {label}
                </Label>
                }
                <div>
                    <InputGroup>
                        {
                            (addon && !addon_end) && <InputGroupAddon addonType="prepend">{addon}</InputGroupAddon>
                        }
                        <Input {...input} rows={rows} placeholder={placeholder || label} type={type} valid={valid} style={style} min={min} max={max}
                               step={step}/>
                        {
                            (addon && addon_end) && <InputGroupAddon addonType="append">{addon}</InputGroupAddon>
                        }
                    </InputGroup>
                    {
                        touched && ((error && !maxChars && <FormFeedback>{error}</FormFeedback>) ||
                            (warning && <FormFeedback>{warning}</FormFeedback>))
                    }

                </div>
            </FormGroup>
        );
    }
}

export class DateField extends Component {
    state = { // Can accept a defaultValue prop that overrides the Redux form value. Handles both string and moment dates
        value: this.props.defaultValue
            ? moment(this.props.defaultValue).format("MM/DD/YYYY")
            : this.props.input.value
                ? moment(this.props.input.value).format("MM/DD/YYYY")
                : ""
    };

    /* Takes input event and an input onChange, onBlur, onFocus, etc.
       Formats the value for the input to MM/DD/YYYY and passes a moment date
       to the Redux form if it is valid (null otherwise)

       Checks that the date is complete and withing +-125 years of the current date
    */
    handleChange = (e, func) => {
        const newValue = normalizeDate(e.target.value, this.state.value);
        this.setState({value: newValue});
        const formValue = (newValue.length === 10
            && moment(newValue).isValid()
            && (moment(newValue).isBetween(moment().subtract(125, 'years'), moment().add(125, 'years')))) ? moment(newValue) : null;
        func(formValue);
    };

    render() {
        const {input, label, placeholder, style, addon, addon_end, meta: {touched, error, warning}} = this.props;
        const validationState = touched ? ((error && 'danger') || (warning && 'danger') || 'default') : 'default';
        const valid = touched ? ((error || warning) ? false : null) : null;
        return (
            <FormGroup color={validationState}>
                {(label === null || label === undefined) ? null : <Label>
                    {label}
                </Label>
                }
                <div>
                    <InputGroup>
                        {
                            (addon && !addon_end) && <InputGroupAddon addonType="prepend">{addon}</InputGroupAddon>
                        }
                        <Input {...input}
                               value={this.state.value}
                               onChange={(e) => this.handleChange(e, input.onChange)}
                               onBlur={(e) => this.handleChange(e, input.onBlur)}
                               placeholder={placeholder || "mm/dd/yyyy"}
                               type="text"
                               valid={valid}
                               style={style}/>
                        {
                            (addon && addon_end) && <InputGroupAddon addonType="append">{addon}</InputGroupAddon>
                        }
                    </InputGroup>
                    {
                        touched && ((error && <FormFeedback>{error}</FormFeedback>) ||
                            (warning && <FormFeedback>{warning}</FormFeedback>))
                    }

                </div>
            </FormGroup>
        );
    }
}

export class SelectField extends Component {
    render() {
        const {label, input, meta: {touched, error, warning}} = this.props;
        const validationState = touched ? ((error && 'danger') || (warning && 'danger') || 'default') : 'default';
        const valid = touched ? ((error || warning) ? false : null) : null;
        return (
            <FormGroup color={validationState}>
                {(label === null || label === undefined) ? null : <Label>
                    {label}
                </Label>
                }
                <div>
                    <Input {...input} type="select" valid={valid}>
                        {
                            this.props.options.map(function (option, i) {
                                return (
                                    <option key={i} value={option.value}>{option.name}</option>
                                );
                            })
                        }
                    </Input>
                    {touched && ((error && <FormFeedback>{error}</FormFeedback>) ||
                        (warning && <FormFeedback>{warning}</FormFeedback>))}

                </div>
            </FormGroup>
        );
    }
}

export class CheckBoxField extends Component {
    render() {
        const {defaultChecked, label, input, meta: {touched, error, warning}} = this.props;
        const validationState = touched ? ((error && 'danger') || (warning && 'warning') || 'default') : 'default';
        const valid = touched ? ((error || warning) ? false : null) : null;
        return (
            <FormGroup check color={validationState} {...this.props}>
                <Label check>
                    {/*<Input {...input} type="checkbox" aria-label={label} state={validationState}/>*/}
                    <Checkbox label={label} valid={valid} defaultChecked={defaultChecked} onChange={input.onChange}/>{' '}
                    {label}
                </Label>
                {touched && ((error && <FormFeedback>{error}</FormFeedback>) ||
                    (warning && <FormFeedback>{warning}</FormFeedback>))}
            </FormGroup>
        );
    }
}

export class StepperField extends Component {
    render() {
        const {label, min, max, value, step, input: {onChange}} = this.props;
        return (
            <div>
                <FormGroup>
                    <Label>
                        <div style={{margin: '0 1em'}}>{label}</div>
                        <Stepper min={min} max={max} value={value} step={step} onChange={onChange}/>
                    </Label>
                </FormGroup>
            </div>
        );
    }
}

export class BoolButtonsField extends Component {
    render() {
        const {label, defaultValue, inverse, input: {onChange}, meta: {touched, error, warning}, trueText, falseText} = this.props;
        const validationState = touched ? ((error && 'danger') || (warning && 'warning') || 'default') : 'default';

        return (
            <div>
                <FormGroup row color={validationState}>
                    <Label sm={7}>
                        {label}
                        {touched && ((error && <FormFeedback>
                                <small>{error}</small>
                            </FormFeedback>) ||
                            (warning && <FormFeedback>
                                <small>{warning}</small>
                            </FormFeedback>))}
                    </Label>
                    <Col sm={5}>
                        <BoolButtons trueText={trueText} falseText={falseText} inverse={inverse} onChange={(e) => onChange(e === 'true' ? true : e === 'false' ? false : null)}
                                     defaultValue={defaultValue}/>
                    </Col>
                </FormGroup>
            </div>
        );
    }
}

export class RheostatField extends Component {
    render() {
        const {min, max, label, color, input: {onChange}} = this.props;
        return (
            <Label style={{color: color}}>
                {label}
                <Rheostat
                    min={min}
                    max={max}
                    values={[min, max]}
                    onValuesUpdated={onChange}
                />
            </Label>
        );
    }
}

export class AddressInputField extends Component {
    /*
    Usage: <Fields names={["place_id", "identifier", "formatted_address"]} component={AddressInputField}>
     */
    state = {
        valid: null
    };

    clear = () => {
        this.geosuggest.update("");
    };

    handleSuggestSelect = (suggest) => {
        if (suggest && PolyUtil.validStreetAddress(suggest.gmaps)) {
            const address = PolyUtil.addressComponentsReader(suggest.gmaps.address_components);
            this.setState({ // valid address
                valid: true,
                error: null
            });
            this.props.place_id.input.onChange(suggest.placeId); // pass place_id to redux form
            this.props.onPlaceIdSelect && this.props.onPlaceIdSelect(suggest.placeId);
            try {
                this.props.formatted_address.input.onChange(suggest.gmaps.formatted_address);
                this.setState(Object.assign(address, {
                    lastGeocode: address.street_address + " " + address.city + ", " + address.state + " " + address.zipcode
                }));
            } catch (e) {
                console.error("Failed to set formatted address");
            }
        }
        else {
            this.setState({ // invalid address
                error: "This appears to be an invalid address- make sure a valid residence was selected.",
                valid: false
            });
        }

    };

    render() {
        const {label, helpText, initialValue, touched, error, warning, placeholder} = this.props;
        const geocodeValidationState = (touched && ((error && "danger") || (warning && "danger"))) || // ReduxForm errors
            (this.state.valid === true && "success") || (this.state.valid === false && "danger") || "default"; // internal errors

        const geosuggestField = <FormGroup color={geocodeValidationState}>
            <Label>{label}</Label>
            <Geosuggest
                ref={node => this.geosuggest = node}
                placeholder={placeholder}
                location={new google.maps.LatLng(35.280422, -120.663902)}
                types={['geocode']}
                initialValue={initialValue}
                onSuggestSelect={this.handleSuggestSelect}
                country="US"
                radius="5000"
                inputClassName={"form-control " + (geocodeValidationState !== "default" && ("form-control-" + geocodeValidationState))}
                disabled={this.props.disabled}
            />
            {this.state.error && <FormFeedback>{this.state.error}</FormFeedback>}
            {touched && ((error && <FormFeedback>{error}</FormFeedback>) ||
                (warning && <FormFeedback>{warning}</FormFeedback>))}
            {helpText && <FormText><i className="fa fa-info-circle"/> {helpText}</FormText>}
        </FormGroup>;

        if (this.props.identifier) {
            return (
                <Row>
                    <Col xs={12} sm={8}>
                        {geosuggestField}
                    </Col>
                    <Col xs={12} sm={4}>
                        <FormGroup>
                            <Label>Apt / Unit #</Label>
                            <Input
                                {...this.props.identifier.input}
                                placeholder=""
                                type="text"
                            />
                        </FormGroup>
                    </Col>
                </Row>
            );
        }
        else {
            return geosuggestField;
        }
    }
}

export class AddressInputFieldAdvanced extends Component {
    /*
    Usage: <Fields names={["place_id", "identifier", "formatted_address"]} component={AddressInputFieldAdvanced}>

    This component stores data using both ReduxForm and React state!!

    ReduxForm:
    - place_id, identifier (final outputs, sent to PolyRents API)

    React state:
    - city, state, zipcode (used for input purposes only, not sent to PolyRents API)
    - lastGeocode (prevents excessive API calls through de-duplication)
    - xxx_valid, xxx_touched (used to provide simple field-specific validation for address detail fields)

     */
    state = {
        lastGeocode: "",
        place_id: "",
        street_address: "",
        city: "",
        state: "",
        zipcode: "",
        valid: null
    };

    clear = () => {
        this.geosuggest.update("");
    };

    componentWillMount() {
        if (this.props.value && this.props.value.place_id) { // use place_id and identifier if they were provided
            PolyUtil.geocodePlace(this.props.value.place_id).then((resp) => {
                this.setState(
                    Object.assign({
                        lastGeocode: resp.street_address + " " + resp.city + ", " + resp.state + " " + resp.zipcode,
                        valid: true
                    }, resp)
                );
                try {
                    this.props.formatted_address.input.onChange(resp.formatted_address);
                } catch (e) {
                    console.error("Failed to set formatted address");
                }
            });
            this.props.identifier.input.onChange(this.props.value.identifier);
        }
    }

    geocode = () => {
        const geocoder = new google.maps.Geocoder();
        const addressString = this.state.street_address + " " + this.state.city + ", " + this.state.state + " " + this.state.zipcode; // Build full address

        if (addressString === this.state.lastGeocode) {
            return new Promise(function (resolve, reject) {
                resolve("Duplicate"); // resolve immediately if same as last geocode request
            });
        }
        else {
            this.setState({lastGeocode: addressString}); // save full address to check for duplicate API calls
            return new Promise(function (resolve, reject) {
                geocoder.geocode({address: addressString, region: 'US'}, function (results, status) {
                    if (status === 'OK') {
                        if (results[0]) {
                            const address = PolyUtil.addressComponentsReader(results[0].address_components);
                            if (PolyUtil.validStreetAddress(results[0])) {
                                resolve(Object.assign(address, {place_id: results[0].place_id}));
                            }
                            else {
                                reject("That address seems to be incomplete, make sure you typed it completely / correctly!");
                            }
                        }
                        else {
                            reject("No results in Google Maps found for the address you entered!");
                            console.error('No results found for place_id given by API');
                        }
                    }
                    else {
                        reject("Geocoder failed due to: " + status);
                        console.error('Geocoder failed due to: ' + status);
                    }
                });
            });
        }
    };

    handleSuggestSelect = (suggest) => {
        const address = PolyUtil.addressComponentsReader(suggest.gmaps.address_components);

        if (PolyUtil.validStreetAddress(suggest.gmaps)) {
            this.setState({ // valid address
                valid: true,
                error: null
            });
            this.props.place_id.input.onChange(suggest.placeId); // pass place_id to redux form
            try {
                this.props.formatted_address.input.onChange(address.formatted_address);
            } catch (e) {
                console.error("Failed to set formatted address");
            }
        }
        else {
            this.setState({ // invalid address
                error: "That address seems to be incomplete, make sure you typed it completely / correctly!",
                valid: false
            });
        }

        this.geosuggest.update(address.street_address); // force Geosuggest to update input field
        this.setState(Object.assign(address, {
            lastGeocode: address.street_address + " " + address.city + ", " + address.state + " " + address.zipcode
        }));
        this.validateAll();
    };

    geocodeIfComplete = () => { // Checks to ensure all fields are complete then attempts geocode
        if (this.allFieldsValid(this.state)) {
            this.geocode().then((resp) => { // Geocode successful
                if (resp !== "Duplicate") {
                    this.props.place_id.input.onChange(resp.place_id);
                    this.setState(Object.assign({}, resp, {valid: true, error: null}));
                    this.geosuggest.update(resp.street_address); // force Geosuggest to update input field
                    this.validateAll();
                    try {
                        this.props.formatted_address.input.onChange(resp.formatted_address);
                    } catch (e) {
                        console.error("Failed to set formatted address");
                    }
                }
                else {
                    this.setState({valid: true});
                }
            }).catch((resp) => {  // Geocode failed
                this.setState({
                    error: resp,
                    valid: false
                });
            });
        }
    };

    validateAll = () => {
        let newState = {
            street_address_valid: this.state.street_address ? this.state.street_address.length > 3 : false,
            city_valid: this.state.city ? this.state.city.length >= 2 : false,
            state_valid: this.state.state ? this.state.state.length === 2 : false,
            zipcode_valid: this.state.zipcode ? this.state.zipcode.length >= 5 : false
        };
        this.setState(Object.assign({
            valid: this.state.valid && this.allFieldsValid(newState)
        }, newState));
    };

    changeStreetAddress = (e) => {
        this.setState({street_address: e, street_address_valid: e ? e.length > 3 : false, touched: true});
    };

    blurField = (name) => {
        let temp = {};
        temp[name + "_touched"] = true;
        this.setState(temp);
        this.geocodeIfComplete();
        this.validateAll();
        if (name === "street_address") {
            this.props.place_id.input.onBlur(); // trigger onBlur for ReduxForm
        }
    };

    changeCity = (e) => {
        this.setState({city: e.target.value, city_valid: e.target.value.length >= 2});
        this.state.valid && this.validateAll(); // check if this change invalidated geocode
    };

    changeState = (e) => {
        this.setState({state: e.target.value, state_valid: e.target.value.length === 2});
        this.state.valid && this.validateAll(); // check if this change invalidated geocode
    };

    changeZipcode = (e) => {
        this.setState({zipcode: e.target.value, zipcode_valid: e.target.value.length >= 5});
        this.state.valid && this.validateAll(); // check if this change invalidated geocode
    };

    allFieldsValid(newState) { // returns true only if all 5 are valid
        return newState.street_address_valid && newState.city_valid && newState.state_valid && newState.zipcode_valid;
    }

    validationState(touched, valid) { // returns validation state string for reactstrap
        return touched ? (valid ? null : "danger") : null;
    }

    render() {
        const {label, placeholder, place_id: {meta: {touched, error, warning}}} = this.props;
        const geocodeValidationState = (touched && ((error && "danger") || (warning && "warning"))) || // ReduxForm errors
            (this.state.valid === true && "success") || (this.state.valid === false && "danger") || "default"; // internal errors

        const geosuggestField = <FormGroup color={geocodeValidationState}>
            <Label>{label}</Label>
            <Geosuggest
                ref={node => this.geosuggest = node}
                placeholder={placeholder}
                location={new google.maps.LatLng(35.280422, -120.663902)}
                types={['geocode']}
                onSuggestSelect={this.handleSuggestSelect}
                onChange={this.changeStreetAddress}
                onBlur={() => this.blurField("street_address")}
                country="US"
                radius="5000"
                inputClassName={"form-control " + (geocodeValidationState !== "default" && ("form-control-" + geocodeValidationState))}
                disabled={this.props.disabled}
            />
            {this.state.error && <FormFeedback>{this.state.error}</FormFeedback>}
            {touched && ((error && <FormFeedback>{error}</FormFeedback>) ||
                (warning && <FormFeedback>{warning}</FormFeedback>))}
        </FormGroup>;

        return (
            <div>
                {this.props.identifier ? <Row>
                    <Col sm="8">
                        {geosuggestField}
                    </Col>
                    <Col sm="4">
                        <FormGroup>
                            <Label>Apt / Unit #</Label>
                            <Input
                                {...this.props.identifier.input}
                                placeholder=""
                                type="text"
                            />
                        </FormGroup>
                    </Col>
                </Row> : geosuggestField
                }
                <Collapse isOpen={this.state.touched}>
                    <Row className={this.state.touched && 'animated fadeIn'}>
                        <Col sm="5">
                            <FormGroup color={this.validationState(this.state.city_touched, this.state.city_valid)}>
                                <Label>City</Label>
                                <Input
                                    value={this.state.city}
                                    onBlur={() => this.blurField("city")}
                                    onChange={this.changeCity}
                                    placeholder="City"
                                    type="text"
                                    state={this.state.city_touched ? this.state.city_valid ? null : "danger" : null}
                                />
                            </FormGroup>
                        </Col>
                        <Col sm="3">
                            <FormGroup color={this.validationState(this.state.state_touched, this.state.state_valid)}>
                                <Label>State</Label>
                                <Input
                                    value={this.state.state}
                                    onBlur={() => this.blurField("state")}
                                    onChange={this.changeState}
                                    placeholder="State"
                                    type="text"
                                    state={this.state.state_touched ? this.state.state_valid ? null : "danger" : null}
                                />
                            </FormGroup>
                        </Col>
                        <Col sm="4">
                            <FormGroup
                                color={this.validationState(this.state.zipcode_touched, this.state.zipcode_valid)}>
                                <Label>Zip Code</Label>
                                <Input
                                    value={this.state.zipcode}
                                    onBlur={() => this.blurField("zipcode")}
                                    onChange={this.changeZipcode}
                                    placeholder="Zipcode"
                                    type="text"
                                    state={this.state.zipcode_touched ? this.state.zipcode_valid ? null : "danger" : null}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </Collapse>
            </div>
        );
    }
}

// special input field for SSN. Adds auto-masking onBlur and CSS class
export class SSNInputField extends Component {
    render() {
        const {input, label, type, placeholder, style, addon, addon_end, meta: {touched, error, warning, active}, maxChars} = this.props;
        const validationState = touched ? ((error && 'danger') || (warning && 'danger') || 'default') : 'default';
        const valid = touched ? ((error || warning) ? false : null) : null;
        const display = input.value ? (input.value.slice(0, 7).replace(/[0-9]/g, "X") + input.value.slice(7, 11)) : "";
        return (
            <FormGroup color={validationState}>
                {(label === null || label === undefined) ? null : <Label>
                    {label}
                </Label>
                }
                <div>
                    <InputGroup>
                        {
                            (addon && !addon_end) && <InputGroupAddon addonType="prepend">{addon}</InputGroupAddon>
                        }
                        <Input
                            value={active ? input.value : display}
                            onChange={active ? input.onChange : () => {}}
                            onFocus={input.onFocus}
                            onBlur={input.onBlur}
                            className="fs-hide"
                            placeholder={placeholder || label}
                            type={type}
                            valid={valid}
                            style={style}
                        />
                        {
                            (addon && addon_end) && <InputGroupAddon addonType="append">{addon}</InputGroupAddon>
                        }
                    </InputGroup>
                    {
                        touched && ((error && !maxChars && <FormFeedback>{error}</FormFeedback>) ||
                            (warning && <FormFeedback>{warning}</FormFeedback>))
                    }
                    <FormText>Encrypted and sent directly to TransUnion</FormText>

                </div>
            </FormGroup>
        );
    }
}



// WEBPACK FOOTER //
// ./src/validation/ReduxFormInput.js